import { Component, AfterViewInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { BfsgAccessibilityService } from './bfsg-accessibility.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { TRANSLATIONS } from './translations';

@Component({
	selector: 'lib-bfsg-accessibility',
	templateUrl: './bfsg-accessibility.component.html',
	styleUrls: ['./styles/bfsg-accessibility.scss', './styles/bfsg-functional.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [BfsgAccessibilityService],
})
export class BfsgAccessibilityComponent implements AfterViewInit, OnDestroy {
	@Input() isMobile: boolean = false;
	@Input() mobileLabel: string = 'Accessibility';

	toolbarVisible = false;
	private routerSub?: Subscription;
	private mutationObserver?: MutationObserver;
	widgetSide: 'left' | 'right' = 'right'; // default side

	constructor(public bfsg: BfsgAccessibilityService, private router: Router, public translate: TranslateService) {
		const langs = Object.keys(TRANSLATIONS);
		const defaultLang = 'de';

		this.translate.addLangs(langs);
		this.translate.setDefaultLang(defaultLang);

		langs.forEach(lang => this.translate.setTranslation(lang, TRANSLATIONS[lang], true));

		const browserLang = this.translate.getBrowserLang();
		const selectedLang = langs.includes(browserLang) ? browserLang : defaultLang;

		this.translate.use(selectedLang);
	}

	ngOnInit() {
		const saved = localStorage.getItem('bfsg-widget-side');
		if (saved === 'left' || saved === 'right') {
			this.widgetSide = saved;
		}
	}

	ngAfterViewInit(): void {
		// Initial settings
		setTimeout(() => this.bfsg.applySavedSettings());

		// Re-apply on route changes
		this.routerSub = this.router.events
			.pipe(filter(e => e instanceof NavigationEnd))
			.subscribe(() => setTimeout(() => this.bfsg.applySavedSettings()));

		// Observe DOM changes
		this.mutationObserver = new MutationObserver(() => {
			this.bfsg.applySavedSettings();
		});

		this.mutationObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	onLangChange(event: Event): void {
		const lang = (event.target as HTMLSelectElement).value;
		this.translate.use(lang);
		this.translate.setTranslation(lang, TRANSLATIONS[lang], true);
	}

	toggleSide(): void {
		this.widgetSide = this.widgetSide === 'right' ? 'left' : 'right';
		localStorage.setItem('bfsg-widget-side', this.widgetSide);
	}

	toggle(key: string): void {
		this.bfsg.toggleFeature(key as any);
	}

	public openPanel() {
		this.toolbarVisible = !this.toolbarVisible;
	}

	resetAll(): void {
		this.toolbarVisible = false;
		this.bfsg.resetAllStyles();
	}

	ngOnDestroy(): void {
		this.routerSub?.unsubscribe();
		this.mutationObserver?.disconnect();
	}
}
